// extracted by mini-css-extract-plugin
module.exports =  {"root":"PG1x1if65uLVvekNOaMl"};